import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage3 from "../HomePage3/HomePage3";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import PricingPage from "../PricingPage/PricingPage";
import ServicePage from "../ServicePage/ServicePage";
import ServiceSinglePage from "../ServiceSinglePage/ServiceSinglePage";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import BlogDetailsPage from "../BlogDetails/BlogDetailsPage";
import ContactPage from "../ContactPage/ContactPage";

// Admins
import AdminLogin from "../../components/Admin/Login";
import Dashboard from "../../components/Admin/Dashboard";
import ManageBlogs from "../../components/Admin/ManageBlogs";
import CreateBlog from "../../components/Admin/CreateBlog";
import EditBlog from "../../components/Admin/EditBlog";
import UserManagement from "../../components/Admin/UserManagement";
import ProtectedRoute from "../../components/Admin/ProtectedRoute";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage3 />} />
          <Route path="home" element={<HomePage3 />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />

          {/* Admin auth */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected admin routes */}
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
          <Route path="/admin/blogs" element={<ProtectedRoute><ManageBlogs /></ProtectedRoute>} />
          <Route path="/admin/blogs/create" element={<ProtectedRoute><CreateBlog /></ProtectedRoute>} />
          <Route path="/admin/blogs/edit/:slug" element={<ProtectedRoute><EditBlog /></ProtectedRoute>} />

          {/* Dynamic SEO-friendly blog URL — must be last to avoid shadowing admin routes */}
          <Route path=":type/:category/:slug" element={<BlogDetailsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
